// Code generated - EDITING IS FUTILE. DO NOT EDIT.
//
// Generated by:
//     public/app/plugins/gen.go
// Using jennies:
//     TSTypesJenny
//     PluginTsTypesJenny
//
// Run 'make gen-cue' from repository root to regenerate.

export const pluginVersion = "11.6.2";

export interface Options {
  selectedSeries: number;
}

export const defaultOptions: Partial<Options> = {
  selectedSeries: 0,
};
